import React, { Component } from 'react';
import RiskAssessmentContent from './RiskAssessmentContent';
import { RuleCategory } from '../../../../services/RuleCategory';

// RuleCategory.FRAUD
class FraudMW extends Component {
    render() {
        return <RiskAssessmentContent ruleCategory={RuleCategory.FRAUD} />;
    }
}

export default FraudMW;
